<template>
    <div class="dashboard-page">
        <!-- 顶部导航组件 -->
        <!-- <Top></Top> -->

        <!-- 主内容区容器 -->
        <div class="dashboard-container">
            <!-- 左侧买家导航 -->
            <aside class="sidebar">
                <!-- 角色标识（保留，便于识别） -->
                <div class="role-tabs">
                    <button class="role-btn active">买家中心</button>
                </div>

                <!-- 买家导航菜单 -->
                <el-menu :default-active="activeMenu" class="nav-menu" background-color="#0f1118" text-color="#e2e8f0"
                    active-text-color="#38bdf8" unique-opened @select="handleMenuSelect">
                    <el-menu-item index="buyer-home"><i class="el-icon-s-home"></i><span
                            slot="title">买家首页</span></el-menu-item>
                    <el-menu-item index="buyer-orders"><i class="el-icon-document"></i><span
                            slot="title">我的订单</span></el-menu-item>
                    <el-menu-item index="buyer-cart"><i class="el-icon-shopping-cart-full"></i><span
                            slot="title">我的购物车</span></el-menu-item>
                    <el-menu-item index="buyer-recharge"><i class="el-icon-coin"></i><span
                            slot="title">充值中心</span></el-menu-item>
                    <el-menu-item index="buyer-funds"><i class="el-icon-money"></i><span
                            slot="title">资金明细</span></el-menu-item>
                    <el-menu-item index="buyer-invoice"><i class="el-icon-postcard"></i><span
                            slot="title">发票管理</span></el-menu-item>
                    <el-menu-item index="buyer-history"><i class="el-icon-time"></i><span
                            slot="title">我的足迹</span></el-menu-item>
                    <el-menu-item index="buyer-collect"><i class="el-icon-star-off"></i><span
                            slot="title">我的收藏</span></el-menu-item>
                    <el-menu-item index="buyer-settings"><i class="el-icon-star-off"></i><span
                            slot="title">密码管理</span></el-menu-item>
                    <!-- <el-submenu index="buyer-more">
                        <template slot="title"><i class="el-icon-more"></i><span>更多功能</span></template>
<el-menu-item index="buyer-settings">账户设置</el-menu-item>
<el-menu-item index="buyer-notify">消息通知</el-menu-item>
<el-menu-item index="buyer-help">帮助中心</el-menu-item>
</el-submenu> -->
                </el-menu>
            </aside>

            <!-- 主内容区域 -->
            <main class="main-content">
                <router-view />
            </main>
        </div>

        <!-- 底部版权组件 -->
        <!-- <Bottom></Bottom> -->
    </div>
</template>

<script>
import Top from '../../components/Header.vue';
import Bottom from '../../components/Footer.vue';

export default {
    name: 'BuyerDashboard',
    components: { Top, Bottom },
    data() {
        return {
            // 去掉固定默认值
            activeMenu: '',
            currentPage: 1,
            pageSize: 10,
            buyerOrderStatus: 'all',
            orderSearchKey: '',
            orderDateRange: [],
            // 买家专属状态映射
            statusTagMap: { pending: 'warning', shipped: 'info', completed: 'success', cancelled: 'danger' },
            buyerStatusTextMap: { pending: '待付款', shipped: '待收货', completed: '已完成', cancelled: '已取消' },
            // 历史记录数据
            historyList: [
                { id: 1, name: '东风41洲际导弹发射车幻想模型', img: 'https://picsum.photos/seed/model1/200/150' },
                { id: 2, name: 'ZTD-05 两栖突击车', img: 'https://picsum.photos/seed/model2/200/150' },
                { id: 3, name: '幻想型怪兽', img: 'https://picsum.photos/seed/model3/200/150' },
                { id: 4, name: '原创角色黑翼天使', img: 'https://picsum.photos/seed/model4/200/150' },
                { id: 5, name: '赛博朋克2077 杰克·威尔斯的夹克', img: 'https://picsum.photos/seed/model5/200/150' },
                { id: 6, name: 'Akane', img: 'https://picsum.photos/seed/model6/200/150' }
            ]
        };
    },
    computed: {
        // 判断是否为买家首页
        isHomePage() {
            const currentPath = this.$route.path;
            return currentPath.includes('buyer/home');
        }
    },
    // 页面创建时立即匹配路由
    created() {
        this.syncActiveMenuFromRoute();
    },
    watch: {
        // 路由监听 + 立即执行
        $route: {
            handler() {
                this.syncActiveMenuFromRoute();
            },
            immediate: true
        }
    },
    methods: {
        // 统一同步激活菜单
        syncActiveMenuFromRoute() {
            const pathSegments = this.$route.path.split('/');
            const page = pathSegments[3];
            if (page) {
                this.activeMenu = `buyer-${page}`;
            } else {
                // 兜底首页
                this.activeMenu = 'buyer-home';
            }
        },

        // 菜单选择：更新激活状态并跳转路由
        handleMenuSelect(key) {
            this.activeMenu = key;
            this.currentPage = 1; // 重置分页
            const [role, page] = key.split('-');
            this.$router.push(`/dashboard/${role}/${page}`);
        },

        // 获取买家页面标题
        getPageTitle() {
            const titleMap = {
                'buyer/home': '买家中心',
                'buyer/orders': '我的订单',
                'buyer/cart': '我的购物车',
                'buyer/recharge': '充值中心',
                'buyer/funds': '资金明细',
                'buyer/invoice': '发票管理',
                'buyer/history': '我的足迹',
                'buyer/collect': '我的收藏',
                'buyer/settings': '账户设置'
            };
            const pathKey = this.$route.path.replace('/dashboard/', '');
            return titleMap[pathKey] || '智步云上-买家中心';
        },

        // 快捷跳转：充值页面
        handleGoRecharge() {
            this.$router.push('/dashboard/buyer/recharge');
        }
    }
};
</script>

<style lang="less" scoped>
// 深色主题配色
@bg-primary: #0f1118;
@text-primary: #e2e8f0;
@text-secondary: #a0aec0;
@accent-blue: #38bdf8;
@accent-red: #ef4444;
@accent-green: #10b981;
@accent-yellow: #f59e0b;
@card-bg: #1e293b;
@border-color: #4a5568;

// 全局样式 - 核心响应式优化
.dashboard-page {
    min-height: 100vh;
    background-color: @bg-primary;
    color: @text-primary;
    display: flex;
    flex-direction: column;
    width: 100%;
    // 移除固定最小宽度限制，解决移动端溢出问题
    // min-width: 1905px; 
    margin: 0 auto;
    overflow-x: hidden; // 防止横向溢出

    // 响应式断点定义
    @media screen and (max-width: 1200px) {
        padding: 0 5px;
    }

    @media screen and (max-width: 992px) {
        padding: 0;
    }

    @media screen and (max-width: 768px) {
        font-size: 14px;
    }

    @media screen and (max-width: 576px) {
        font-size: 13px;
    }
}

.dashboard-container {
    display: flex;
    flex: 1;
    gap: 15px;
    height: calc(100vh - 130px);
    overflow: hidden;
    width: 100%;
    box-sizing: border-box;
    padding: 0 10px;

    // 响应式布局调整
    @media screen and (max-width: 992px) {
        gap: 10px;
        padding: 0 5px;
        height: calc(100vh - 120px);
    }

    @media screen and (max-width: 768px) {
        flex-direction: column; // 移动端垂直布局
        height: auto;
        min-height: calc(100vh - 120px);
        gap: 15px;
        padding: 10px 5px;
    }

    @media screen and (max-width: 576px) {
        gap: 10px;
        padding: 5px;
    }
}

// 左侧侧边栏样式 - 响应式优化
.sidebar {
    width: 220px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    height: 100%;
    background-color: #080a12;
    flex-shrink: 0; // 防止侧边栏被压缩

    // 响应式调整
    @media screen and (max-width: 992px) {
        width: 200px;
    }

    @media screen and (max-width: 768px) {
        width: 100%;
        height: auto;
        max-height: 50vh;
        overflow-y: auto;
    }

    @media screen and (max-width: 576px) {
        width: 100%;
        gap: 5px;
    }

    .role-tabs {
        display: flex;
        border-bottom: 1px solid @border-color;

        @media screen and (max-width: 576px) {
            border-bottom: 1px solid rgba(74, 85, 104, 0.5);
        }

        .role-btn {
            flex: 1;
            padding: 12px 0;
            background: #1a202c;
            border: none;
            color: @text-secondary;
            font-size: 16px;
            cursor: default;
            transition: all 0.3s;

            &.active {
                background: @card-bg;
                color: @accent-blue;
            }

            // 响应式调整
            @media screen and (max-width: 992px) {
                padding: 10px 0;
                font-size: 15px;
            }

            @media screen and (max-width: 576px) {
                padding: 8px 0;
                font-size: 14px;
            }
        }
    }

    .nav-menu {
        border-radius: 4px;
        height: calc(100% - 50px);
        border-right: none;

        // 响应式调整
        @media screen and (max-width: 768px) {
            height: auto;
            max-height: calc(100% - 46px);
        }

        @media screen and (max-width: 576px) {
            height: auto;
            max-height: 300px;
        }

        &::-webkit-scrollbar {
            width: 6px;
        }

        &::-webkit-scrollbar-thumb {
            background-color: rgba(56, 189, 248, 0.3);
            border-radius: 3px;
        }

        // 菜单样式优化：点击区域扩大
        .el-menu-item {
            height: auto !important;
            cursor: pointer;
            width: 100%;
            box-sizing: border-box;

            &.is-active {
                background-color: rgba(56, 189, 248, 0.1) !important;
                color: @accent-blue !important;
                border-left: 3px solid @accent-blue;
            }

            &:hover {
                background-color: rgba(56, 189, 248, 0.05) !important;
            }

            >div {
                width: 100%;
                display: flex;
                align-items: center;
                gap: 10px;
                padding: 8px 15px; // 增加内边距，提升触控体验

                @media screen and (max-width: 576px) {
                    padding: 10px 15px;
                    gap: 8px;
                }
            }

            span[slot="title"] {
                flex: 1;
                display: inline-block;
                padding: 5px 0;

                @media screen and (max-width: 576px) {
                    font-size: 13px;
                }
            }

            i {
                font-size: 16px;

                @media screen and (max-width: 576px) {
                    font-size: 14px;
                }
            }
        }
    }
}

// 主内容区样式 - 响应式优化
.main-content {
    flex: 1;
    overflow-y: auto;
    padding: 5px;
    min-width: 0; // 解决flex容器溢出问题

    // 响应式调整
    @media screen and (max-width: 992px) {
        padding: 5px;
    }

    @media screen and (max-width: 768px) {
        padding: 10px;
        overflow-y: visible;
    }

    @media screen and (max-width: 576px) {
        padding: 5px;
    }

    .page-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 15px;

        // 响应式调整
        @media screen and (max-width: 768px) {
            margin-bottom: 12px;
            flex-wrap: wrap;
            gap: 10px;
        }

        @media screen and (max-width: 576px) {
            margin-bottom: 10px;
            flex-direction: column;
            align-items: flex-start;
        }

        .page-title {
            font-size: 20px;
            color: @text-primary;
            margin: 0;

            // 响应式调整
            @media screen and (max-width: 992px) {
                font-size: 18px;
            }

            @media screen and (max-width: 576px) {
                font-size: 16px;
            }
        }
    }

    // 用户信息卡片样式
    .user-info-card {
        margin-bottom: 15px;
        background: #080a12;
        border: none;

        // 响应式调整
        @media screen and (max-width: 768px) {
            margin-bottom: 12px;
        }

        @media screen and (max-width: 576px) {
            margin-bottom: 10px;
        }

        .user-info-wrapper {
            display: flex;
            flex-wrap: wrap; // 允许换行
            gap: 20px;
            align-items: center;

            // 响应式调整
            @media screen and (max-width: 992px) {
                gap: 15px;
            }

            @media screen and (max-width: 768px) {
                flex-direction: column;
                align-items: flex-start;
                gap: 15px;
            }

            @media screen and (max-width: 576px) {
                gap: 10px;
            }

            .user-avatar-section {
                display: flex;
                align-items: center;
                gap: 15px;
                flex: 1;
                min-width: 280px; // 最小宽度保证布局

                // 响应式调整
                @media screen and (max-width: 768px) {
                    width: 100%;
                    min-width: 0;
                }

                @media screen and (max-width: 576px) {
                    gap: 10px;
                    flex-direction: column;
                    align-items: flex-start;
                }

                .user-avatar {
                    border: 3px solid #f0f2f5;
                    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

                    // 响应式调整
                    @media screen and (max-width: 576px) {
                        width: 60px !important;
                        height: 60px !important;
                    }
                }

                .user-base-info {
                    .user-name-role {
                        display: flex;
                        align-items: center;
                        gap: 10px;
                        margin-bottom: 8px;

                        // 响应式调整
                        @media screen and (max-width: 576px) {
                            margin-bottom: 5px;
                            gap: 8px;
                        }

                        .user-name {
                            font-size: 18px;
                            margin: 0;
                            color: #fff;

                            // 响应式调整
                            @media screen and (max-width: 992px) {
                                font-size: 16px;
                            }

                            @media screen and (max-width: 576px) {
                                font-size: 15px;
                            }
                        }
                    }

                    .user-memorial {
                        font-size: 13px;
                        color: @text-secondary;
                        line-height: 1.6;
                        margin: 0 0 10px 0;

                        // 响应式调整
                        @media screen and (max-width: 576px) {
                            font-size: 12px;
                            margin-bottom: 8px;
                        }
                    }

                    .user-actions {
                        display: flex;
                        gap: 10px;

                        // 响应式调整
                        @media screen and (max-width: 576px) {
                            gap: 8px;
                            flex-wrap: wrap;
                        }
                    }
                }
            }

            .user-stats {
                display: flex;
                align-items: center;
                gap: 20px;
                min-width: 300px;

                // 响应式调整
                @media screen and (max-width: 992px) {
                    gap: 15px;
                    min-width: 250px;
                }

                @media screen and (max-width: 768px) {
                    width: 100%;
                    min-width: 0;
                    justify-content: space-around;
                }

                @media screen and (max-width: 576px) {
                    gap: 10px;
                    justify-content: space-between;
                }

                .stat-item {
                    text-align: center;
                    min-width: 80px;

                    // 响应式调整
                    @media screen and (max-width: 576px) {
                        min-width: 60px;
                    }
                }
            }
        }
    }

    // 内容卡片通用样式
    .content-card {
        color: #fff;
        margin-bottom: 15px;
        background: #080a12;
        border: none;

        // 响应式调整
        @media screen and (max-width: 768px) {
            margin-bottom: 12px;
        }

        @media screen and (max-width: 576px) {
            margin-bottom: 10px;
        }

        .card-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px 15px;

            // 响应式调整
            @media screen and (max-width: 576px) {
                flex-wrap: wrap;
                gap: 8px;
                padding: 8px 10px;
            }

            .card-title {
                font-size: 16px;
                font-weight: 500;

                // 响应式调整
                @media screen and (max-width: 992px) {
                    font-size: 15px;
                }

                @media screen and (max-width: 576px) {
                    font-size: 14px;
                }
            }

            .more-link,
            .refresh-btn {
                font-size: 13px;
                padding: 0;

                // 响应式调整
                @media screen and (max-width: 576px) {
                    font-size: 12px;
                }
            }
        }
    }

    // 订单筛选栏样式
    .order-filter-bar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 15px;
        padding: 0 5px;
        flex-wrap: wrap; // 允许换行
        gap: 10px;

        // 响应式调整
        @media screen and (max-width: 768px) {
            margin-bottom: 12px;
            flex-direction: column;
            align-items: flex-start;
        }

        @media screen and (max-width: 576px) {
            margin-bottom: 10px;
            gap: 8px;
        }

        .status-filter {
            display: flex;
            gap: 8px;
            flex-wrap: wrap;

            // 响应式调整
            @media screen and (max-width: 576px) {
                gap: 5px;
                width: 100%;
            }

            .el-radio-button {
                background-color: #2d3748;
                border-color: @border-color;
                color: @text-secondary;
                font-size: 12px;

                // 响应式调整
                @media screen and (max-width: 576px) {
                    padding: 5px 8px;
                    font-size: 11px;
                }

                &.is-active {
                    background-color: @accent-blue;
                    border-color: @accent-blue;
                    color: #fff;
                }
            }
        }

        .order-search {
            width: 260px;

            // 响应式调整
            @media screen and (max-width: 768px) {
                width: 100%;
            }

            .el-input__inner {
                background-color: #2d3748;
                border-color: @border-color;
                color: @text-primary;

                // 响应式调整
                @media screen and (max-width: 576px) {
                    font-size: 12px;
                    padding: 8px 10px;
                }
            }
        }
    }

    // 原生订单表格样式
    .native-table-container {
        overflow-x: auto;
        margin-bottom: 15px;

        // 响应式调整
        @media screen and (max-width: 768px) {
            margin-bottom: 12px;
        }

        @media screen and (max-width: 576px) {
            margin-bottom: 10px;
        }
    }

    .native-order-table {
        width: 100%;
        border-collapse: collapse;
        color: @text-primary;
        min-width: 600px; // 保证表格最小宽度，允许横向滚动

        // 响应式调整
        @media screen and (max-width: 768px) {
            min-width: 500px;
            font-size: 13px;
        }

        @media screen and (max-width: 576px) {
            min-width: 400px;
            font-size: 12px;
        }

        th {
            background-color: #2d3748;
            padding: 12px 8px;
            text-align: left;
            border: 1px solid @border-color;
            font-weight: 500;

            // 响应式调整
            @media screen and (max-width: 768px) {
                padding: 10px 6px;
            }

            @media screen and (max-width: 576px) {
                padding: 8px 4px;
                font-size: 11px;
            }
        }

        td {
            padding: 12px 8px;
            border: 1px solid @border-color;

            // 响应式调整
            @media screen and (max-width: 768px) {
                padding: 10px 6px;
            }

            @media screen and (max-width: 576px) {
                padding: 8px 4px;
            }
        }

        .order-row {
            background-color: @card-bg;
            transition: background-color 0.2s;

            &:hover {
                background-color: #232f45;
            }
        }

        .empty-row {
            background-color: @card-bg;

            td {
                color: @text-secondary;
                text-align: center;
            }
        }

        // 商品信息样式
        .order-product-info {
            display: flex;
            align-items: center;
            gap: 10px;

            // 响应式调整
            @media screen and (max-width: 576px) {
                gap: 5px;
            }

            .product-thumb {
                width: 40px;
                height: 40px;
                border-radius: 4px;
                object-fit: cover;

                // 响应式调整
                @media screen and (max-width: 576px) {
                    width: 30px;
                    height: 30px;
                }
            }

            .product-name {
                max-width: 220px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;

                // 响应式调整
                @media screen and (max-width: 768px) {
                    max-width: 150px;
                }

                @media screen and (max-width: 576px) {
                    max-width: 100px;
                }
            }
        }

        // 买家信息样式
        .buyer-info {
            display: flex;
            align-items: center;
            gap: 8px;

            // 响应式调整
            @media screen and (max-width: 576px) {
                gap: 5px;
            }

            .buyer-avatar {
                width: 30px;
                height: 30px;
                border-radius: 10%;
                object-fit: cover;

                // 响应式调整
                @media screen and (max-width: 576px) {
                    width: 25px;
                    height: 25px;
                }
            }

            .buyer-name {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                max-width: 120px;

                // 响应式调整
                @media screen and (max-width: 576px) {
                    max-width: 80px;
                }
            }
        }

        // 金额文本样式
        .amount-text {
            color: @accent-red;
            font-weight: 500;
        }

        // 订单状态标签样式
        .status-tag {
            display: inline-block;
            padding: 3px 8px;
            border-radius: 4px;
            font-size: 12px;

            // 响应式调整
            @media screen and (max-width: 576px) {
                padding: 2px 6px;
                font-size: 11px;
            }

            &--warning {
                background-color: rgba(245, 158, 11, 0.2);
                color: @accent-yellow;
                border: 1px solid @accent-yellow;
            }

            &--info {
                background-color: rgba(56, 189, 248, 0.2);
                color: @accent-blue;
                border: 1px solid @accent-blue;
            }

            &--success {
                background-color: rgba(16, 185, 129, 0.2);
                color: @accent-green;
                border: 1px solid @accent-green;
            }

            &--danger {
                background-color: rgba(239, 68, 68, 0.2);
                color: @accent-red;
                border: 1px solid @accent-red;
            }
        }
    }

    // 原生按钮样式
    .native-btn {
        padding: 4px 12px;
        border-radius: 4px;
        font-size: 12px;
        cursor: pointer;
        border: none;
        transition: background-color 0.2s;

        // 响应式调整 - 增大移动端按钮尺寸
        @media screen and (max-width: 576px) {
            padding: 6px 10px;
            font-size: 12px;
            min-height: 30px;
        }

        &--primary {
            background-color: @accent-blue;
            color: #fff;

            &:hover {
                background-color: #25a5e7;
            }
        }

        &--success {
            background-color: @accent-green;
            color: #fff;

            &:hover {
                background-color: #0e9f7a;
            }
        }

        &--info {
            background-color: #4a5568;
            color: @text-primary;

            &:hover {
                background-color: #374151;
            }
        }

        &--text {
            background-color: transparent;
            padding: 4px 8px;

            // 响应式调整
            @media screen and (max-width: 576px) {
                padding: 6px 8px;
            }

            &.detail-btn {
                color: @accent-blue;

                &:hover {
                    color: #25a5e7;
                    text-decoration: underline;
                }
            }

            &.cancel-btn {
                color: @accent-red;

                &:hover {
                    color: #dc2626;
                    text-decoration: underline;
                }
            }
        }
    }

    // 原生分页样式
    .native-pagination {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: 15px;
        color: @text-secondary;
        font-size: 13px;
        flex-wrap: wrap; // 允许换行

        // 响应式调整
        @media screen and (max-width: 768px) {
            gap: 10px;
            font-size: 12px;
            justify-content: center;
        }

        @media screen and (max-width: 576px) {
            gap: 8px;
            font-size: 11px;
        }

        .pagination-total {
            margin-right: auto;

            // 响应式调整
            @media screen and (max-width: 768px) {
                margin-right: 0;
                width: 100%;
                text-align: center;
                margin-bottom: 5px;
            }
        }

        .pagination-sizes {
            display: flex;
            align-items: center;
            gap: 8px;

            // 响应式调整
            @media screen and (max-width: 576px) {
                gap: 5px;
            }

            .pagination-select {
                background-color: #2d3748;
                border: 1px solid @border-color;
                color: @text-primary;
                padding: 4px 8px;
                border-radius: 4px;
                cursor: pointer;

                // 响应式调整
                @media screen and (max-width: 576px) {
                    padding: 4px 6px;
                    font-size: 11px;
                }
            }
        }

        .pagination-pages {
            display: flex;
            align-items: center;
            gap: 8px;

            // 响应式调整
            @media screen and (max-width: 576px) {
                gap: 5px;
            }

            .pagination-btn {
                background-color: #2d3748;
                border: 1px solid @border-color;
                color: @text-secondary;
                padding: 4px 12px;
                border-radius: 4px;
                cursor: pointer;

                // 响应式调整
                @media screen and (max-width: 576px) {
                    padding: 4px 8px;
                    min-width: 30px;
                }

                &:hover:not(:disabled) {
                    background-color: #374151;
                    color: @accent-blue;
                }

                &:disabled {
                    opacity: 0.5;
                    cursor: not-allowed;
                }
            }

            .pagination-current {
                padding: 4px 12px;
                background-color: @accent-blue;
                color: #fff;
                border-radius: 4px;

                // 响应式调整
                @media screen and (max-width: 576px) {
                    padding: 4px 8px;
                    min-width: 30px;
                    text-align: center;
                }
            }
        }
    }

    // 购物车空状态样式
    .cart-empty {
        text-align: center;
        padding: 50px 0;
        color: @text-secondary;

        // 响应式调整
        @media screen and (max-width: 768px) {
            padding: 40px 0;
        }

        @media screen and (max-width: 576px) {
            padding: 30px 0;
        }

        .empty-img {
            width: 120px;
            height: 120px;
            margin-bottom: 15px;
            opacity: 0.6;

            // 响应式调整
            @media screen and (max-width: 768px) {
                width: 100px;
                height: 100px;
                margin-bottom: 12px;
            }

            @media screen and (max-width: 576px) {
                width: 80px;
                height: 80px;
                margin-bottom: 10px;
            }
        }

        .empty-text {
            font-size: 16px;
            margin-bottom: 20px;

            // 响应式调整
            @media screen and (max-width: 768px) {
                font-size: 14px;
                margin-bottom: 15px;
            }

            @media screen and (max-width: 576px) {
                font-size: 13px;
                margin-bottom: 10px;
            }
        }
    }

    // 购物车数量调整样式
    .quantity-controls {
        display: flex;
        align-items: center;
        gap: 8px;

        // 响应式调整
        @media screen and (max-width: 576px) {
            gap: 5px;
        }

        .quantity-btn {
            width: 28px;
            height: 28px;
            border-radius: 4px;
            border: 1px solid @border-color;
            background-color: #2d3748;
            color: @text-primary;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;

            // 响应式调整 - 增大移动端按钮
            @media screen and (max-width: 576px) {
                width: 32px;
                height: 32px;
            }

            &:disabled {
                opacity: 0.5;
                cursor: not-allowed;
            }
        }

        .quantity-input {
            width: 50px;
            height: 28px;
            border-radius: 4px;
            border: 1px solid @border-color;
            background-color: #2d3748;
            color: @text-primary;
            text-align: center;
            outline: none;

            // 响应式调整
            @media screen and (max-width: 576px) {
                width: 60px;
                height: 32px;
                font-size: 14px;
            }

            &:focus {
                border-color: @accent-blue;
            }
        }
    }

    // 购物车结算栏样式
    .cart-settlement {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 15px;
        padding: 12px 16px;
        background-color: #2d3748;
        border-radius: 4px;
        flex-wrap: wrap; // 允许换行
        gap: 10px;

        // 响应式调整
        @media screen and (max-width: 768px) {
            margin-top: 12px;
            padding: 10px 12px;
        }

        @media screen and (max-width: 576px) {
            margin-top: 10px;
            padding: 8px 10px;
            flex-direction: column;
            align-items: flex-start;
        }

        .settlement-left {

            // 响应式调整
            @media screen and (max-width: 576px) {
                width: 100%;
                margin-bottom: 5px;
            }

            .native-btn--text {
                color: @text-secondary;

                &:hover {
                    color: @accent-blue;
                    text-decoration: underline;
                }
            }
        }

        .settlement-right {
            display: flex;
            align-items: center;
            gap: 20px;

            // 响应式调整
            @media screen and (max-width: 768px) {
                gap: 15px;
            }

            @media screen and (max-width: 576px) {
                width: 100%;
                justify-content: space-between;
                gap: 10px;
            }

            .settlement-summary {
                display: flex;
                gap: 20px;
                color: @text-primary;

                // 响应式调整
                @media screen and (max-width: 768px) {
                    gap: 15px;
                }

                @media screen and (max-width: 576px) {
                    gap: 10px;
                }

                .highlight {
                    color: @accent-red;
                    font-weight: 500;
                    font-size: 15px;

                    // 响应式调整
                    @media screen and (max-width: 576px) {
                        font-size: 14px;
                    }
                }
            }

            .native-btn--primary {
                padding: 8px 24px;
                font-size: 14px;

                // 响应式调整
                @media screen and (max-width: 768px) {
                    padding: 8px 20px;
                    font-size: 13px;
                }

                @media screen and (max-width: 576px) {
                    padding: 10px 20px;
                    font-size: 13px;
                    width: 100%;
                    text-align: center;
                }

                &:disabled {
                    opacity: 0.5;
                    cursor: not-allowed;
                }
            }
        }
    }

    // 买家内容区专属样式
    .buyer-content {
        .history-grid {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
            gap: 15px;
            padding: 5px 0;

            // 响应式调整
            @media screen and (max-width: 992px) {
                grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
                gap: 12px;
            }

            @media screen and (max-width: 768px) {
                grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
                gap: 10px;
            }

            @media screen and (max-width: 576px) {
                grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
                gap: 8px;
            }

            .history-item {
                display: flex;
                flex-direction: column;
                gap: 8px;

                // 响应式调整
                @media screen and (max-width: 576px) {
                    gap: 5px;
                }

                .history-img-container {
                    width: 100%;
                    height: 130px;
                    border-radius: 4px;
                    overflow: hidden;
                    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

                    // 响应式调整
                    @media screen and (max-width: 992px) {
                        height: 120px;
                    }

                    @media screen and (max-width: 768px) {
                        height: 100px;
                    }

                    @media screen and (max-width: 576px) {
                        height: 80px;
                    }

                    .history-img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        transition: transform 0.3s;

                        &:hover {
                            transform: scale(1.05);
                        }
                    }
                }

                .history-name {
                    font-size: 14px;
                    color: @text-primary;
                    margin: 0;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;

                    // 响应式调整
                    @media screen and (max-width: 768px) {
                        font-size: 13px;
                    }

                    @media screen and (max-width: 576px) {
                        font-size: 12px;
                    }
                }

                .history-actions {
                    display: flex;
                    justify-content: space-between;
                    padding: 0 5px;

                    // 响应式调整
                    @media screen and (max-width: 576px) {
                        padding: 0;
                    }
                }
            }
        }

        .recommend-grid {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
            gap: 15px;
            padding: 5px 0;

            // 响应式调整
            @media screen and (max-width: 1200px) {
                grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
            }

            @media screen and (max-width: 992px) {
                grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
                gap: 12px;
            }

            @media screen and (max-width: 768px) {
                grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
                gap: 10px;
            }

            @media screen and (max-width: 576px) {
                grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
                gap: 8px;
            }

            .recommend-card {
                background: transparent;
                border: none;
                overflow: hidden;
                transition: transform 0.3s;

                &:hover {
                    transform: translateY(-3px);
                }

                .recommend-img-container {
                    position: relative;
                    height: 180px;
                    overflow: hidden;

                    // 响应式调整
                    @media screen and (max-width: 992px) {
                        height: 150px;
                    }

                    @media screen and (max-width: 768px) {
                        height: 120px;
                    }

                    @media screen and (max-width: 576px) {
                        height: 100px;
                    }

                    .recommend-img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }

                    .recommend-tag {
                        position: absolute;
                        top: 8px;
                        right: 8px;
                        background-color: rgba(56, 189, 248, 0.2);
                        color: @accent-blue;
                        font-size: 12px;
                        padding: 2px 8px;
                        border-radius: 4px;

                        // 响应式调整
                        @media screen and (max-width: 576px) {
                            font-size: 10px;
                            padding: 1px 6px;
                            top: 5px;
                            right: 5px;
                        }
                    }
                }

                .recommend-info {
                    padding: 10px;

                    // 响应式调整
                    @media screen and (max-width: 768px) {
                        padding: 8px;
                    }

                    @media screen and (max-width: 576px) {
                        padding: 5px;
                    }

                    .recommend-name {
                        color: #fff;
                        font-size: 15px;
                        margin: 0 0 8px 0;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        overflow: hidden;
                        height: 36px;

                        // 响应式调整
                        @media screen and (max-width: 768px) {
                            font-size: 14px;
                            height: 32px;
                            margin-bottom: 5px;
                        }

                        @media screen and (max-width: 576px) {
                            font-size: 12px;
                            height: 28px;
                            margin-bottom: 3px;
                        }
                    }

                    .recommend-meta {
                        display: flex;
                        justify-content: space-between;
                        font-size: 12px;
                        color: @text-secondary;
                        margin-bottom: 8px;

                        // 响应式调整
                        @media screen and (max-width: 768px) {
                            font-size: 11px;
                            margin-bottom: 5px;
                        }

                        @media screen and (max-width: 576px) {
                            font-size: 10px;
                            margin-bottom: 3px;
                            flex-wrap: wrap;
                            gap: 3px;
                        }
                    }

                    .recommend-price {
                        .free {
                            color: @accent-green;
                            font-weight: 500;
                        }

                        .paid {
                            color: @accent-red;
                            font-weight: 500;
                        }

                        // 响应式调整
                        @media screen and (max-width: 576px) {
                            font-size: 12px;
                        }
                    }
                }
            }
        }
    }
}

// Element组件样式适配
.el-card__header {
    border-bottom: 1px solid transparent;
}

.el-tag--warning {
    background-color: rgba(245, 158, 11, 0.2);
    border-color: @accent-yellow;
    color: @accent-yellow;
}

.el-tag--info {
    background-color: rgba(56, 189, 248, 0.2);
    border-color: @accent-blue;
    color: @accent-blue;
}

.el-tag--success {
    background-color: rgba(16, 185, 129, 0.2);
    border-color: @accent-green;
    color: @accent-green;
}

.el-tag--danger {
    background-color: rgba(239, 68, 68, 0.2);
    border-color: @accent-red;
    color: @accent-red;
}

// 滚动条样式优化
::-webkit-scrollbar {
    width: 8px;
    height: 8px;
}

::-webkit-scrollbar-track {
    background: #1a202c;
    border-radius: 4px;
}

::-webkit-scrollbar-thumb {
    background: #4a5568;
    border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
    background: #718096;
}

// 响应式补充：小屏设备Element UI适配
@media screen and (max-width: 576px) {
    .el-menu {
        --el-menu-text-color: #e2e8f0;
        --el-menu-active-text-color: #38bdf8;
        --el-menu-hover-text-color: #38bdf8;
    }

    .el-menu-item {
        padding: 0 10px !important;
    }
}
</style>